var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInformationsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9983 22.5019L10.4969 22.4989C7.182 22.4989 4.49438 19.8098 4.49438 16.4934V14.9973C4.49438 11.6809 7.182 8.99326 10.4984 8.99326H20.9998L26.8102 5.02261C28.803 3.66154 31.5056 5.08864 31.5056 7.50164V23.9965C31.5056 26.4095 28.8015 27.8366 26.8102 26.474L20.9983 22.5019Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0013 8.99622V22.5018",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99628 22.5018L11.2907 28.2912C11.7004 29.3267 12.6938 30.005 13.7968 30.005V30.005C15.7041 30.005 17.0096 28.0631 16.3058 26.2729L14.8217 22.5018",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInformationsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/InformationsIcon.0bd24bba.svg";
export { ForwardRef as ReactComponent };